import { render, staticRenderFns } from "./herdsman.vue?vue&type=template&id=09cd486f"
import script from "./herdsman.vue?vue&type=script&lang=js"
export * from "./herdsman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports